import React from 'react';

import { Button as CTAButton, EnvelopeIcon, PhoneIcon } from '@motorway/mw-highway-code';
import { BUTTON_AS_TYPE, VARIANT } from '@motorway/mw-highway-code/enums';
import { Variant } from '@motorway/mw-highway-code/src/types';

type EmailProps = {
  email: string;
  onClick?: () => void;
}

type PhoneProps = {
  className?: string;
  disabled?: boolean;
  innerClassName?: string;
  landlineNoSpace: string;
  landlineWithSpace: string;
  onClick?: () => void;
  variant?: Variant;
};

const Email = ({ email, onClick }: EmailProps) => (
  <CTAButton
    {...{ onClick }}
    data-thc-email-button
    fullWidth
    reverse
    as={BUTTON_AS_TYPE.ANCHOR}
    href={`mailto:${email}`}
    icon={EnvelopeIcon}
    label="Email"
    variant={VARIANT.SECONDARY}
  />
);

const Phone = ({
  disabled = false,
  landlineNoSpace,
  landlineWithSpace,
  onClick,
  variant,
}: PhoneProps) => (
  <CTAButton
    {...{ disabled, onClick, variant }}
    data-thc-phone-button
    fullWidth
    reverse
    as={BUTTON_AS_TYPE.ANCHOR}
    href={`tel:${landlineNoSpace}`}
    icon={PhoneIcon}
    label={ landlineWithSpace }
  />
);

export { Email, Phone };
